import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { AlertTitle } from '@mui/material';

const SnackbarComponent = ({
  open,
  autoHide = 6000,
  handleClose,
  message,
  severity = 'success',
  body,
  variant = 'filled',
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHide}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={severity} variant={variant} sx={{ width: '100%' }}>
        <AlertTitle>{message}</AlertTitle>
        {body}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarComponent;
